import {createContext, useEffect, useState} from "react";
import axios from "axios";
import { useAuthState } from 'react-firebase-hooks/auth';
import {BASE_HOST, getAccountAPIHeader} from "../../utils/urlConst";
import { auth } from '../../firebase';


const SitesContext = createContext({
    sites: [],
    setSites: () => Promise.resolve()
});


function SitesProvider({children}) {
    const [sites, setSites] = useState([]);
    const [user] = useAuthState(auth);
    console.log("Sites Provider Initialized");

    useEffect(() => {
        user.getIdToken().then((idToken) => {
          if (idToken){
          axios.get(`${BASE_HOST}/api/basic/sites`, getAccountAPIHeader(idToken))
            .then((out) => {
              setSites(out.data.sites)
            });
          }
        })
    }, []);




    return (
        <SitesContext.Provider
            value={{
                sites,
                setSites
            }}
        >
            {children}
        </SitesContext.Provider>
    );
}

export {SitesProvider, SitesContext};